/**
 * Configuration de React Query pour le cache des données
 * - Cache intelligent des requêtes
 * - Revalidation automatique
 * - Gestion optimiste des mutations
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Configuration du client React Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache par défaut : 5 minutes
      staleTime: 5 * 60 * 1000,
      // Garder en cache 30 minutes
      gcTime: 30 * 60 * 1000,
      // Retry 1 fois en cas d'erreur
      retry: 1,
      // Ne pas refetch au focus pour les données qui changent rarement
      refetchOnWindowFocus: false,
      // Refetch au reconnect
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry 0 fois pour les mutations
      retry: 0,
    },
  },
});

// Keys pour le cache - centraliser pour éviter les typos
export const queryKeys = {
  // Restaurants
  restaurants: ['restaurants'],
  restaurantsList: (filters) => ['restaurants', 'list', filters],
  restaurantDetail: (id) => ['restaurants', 'detail', id],
  restaurantDishes: (id) => ['restaurants', id, 'dishes'],
  restaurantCategories: (id) => ['restaurants', id, 'categories'],
  restaurantReviews: (id) => ['restaurants', id, 'reviews'],
  
  // User
  currentUser: ['user', 'current'],
  userOrders: ['user', 'orders'],
  userFavorites: ['user', 'favorites'],
  
  // Cart
  cart: ['cart'],
  
  // Restaurant Dashboard
  dashboardStats: ['dashboard', 'stats'],
  dashboardOrders: ['dashboard', 'orders'],
  dashboardTodayOrders: ['dashboard', 'orders', 'today'],
  
  // Admin
  adminStats: ['admin', 'stats'],
  adminUsers: ['admin', 'users'],
  adminRestaurants: ['admin', 'restaurants'],
};

// Provider wrapper
export function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}

export default QueryProvider;
